module.exports = __webpack_public_path__ + "img/clinicIconA.9152081e.svg";